import type {
  ICarCompareClickEvent,
  ICarCompareClickInput,
} from '../types/clickEvents';

const carCompareClick = (
  input: ICarCompareClickInput,
): Omit<ICarCompareClickEvent, 'event'> => ({
  linkDetails: input.linkDetails,
});

export default carCompareClick;
